import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useHomeListSectionsQuery, useHomeUpdateSectionsMutation } from "../../../../Services/HomeAPI";
import { useNavigate } from "react-router-dom";

function AddCategory() {
    const navigate = useNavigate();
    const { data, isLoading: isLoadingContent, error, refetch } = useHomeListSectionsQuery();
    const [listData, setListData] = useState([]);


    useEffect(() => {
        if (data?.data) {
            const bestSellerData = data?.data?.filter(item => item.product_source === "new_arrivals");
            setListData(bestSellerData);
        }
    }, [data]);

    const [title, setTitle] = useState("");
    const [isTitleActive, setIsTitleActive] = useState(1);
    const [smallHeading, setSmallHeading] = useState("");
    const [isSmallHeadingActive, setIsSmallHeadingActive] = useState(1);
    const [description, setDescription] = useState("");
    const [isDescriptionActive, setIsDescriptionActive] = useState(1);


    const [isActive, setIsActive] = useState(1);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState(null);
    useEffect(() => {
        refetch();
    }, [refetch])

    const [UpdateLIst, { isLoading }] = useHomeUpdateSectionsMutation();

    useEffect(() => {
        setTitle(listData?.[0]?.title || "");
        setIsTitleActive(listData?.[0]?.is_title_active ? 1 : 0);
        setSmallHeading(listData?.[0]?.small_heading || "");
        setIsSmallHeadingActive(listData?.[0]?.is_small_heading_active ? 1 : 0);
        setDescription(listData?.[0]?.description || "");
        setIsDescriptionActive(listData?.[0]?.is_description_active ? 1 : 0);
        setIsActive(listData?.[0]?.is_active ? 1 : 0)
    }, [listData])

    const validateForm = () => {
        let newErrors = {};
        if (!title.trim()) newErrors.title = "Title is required";
        if (!smallHeading.trim()) newErrors.smallHeading = "Small heading is required";
        if (!description.trim()) newErrors.description = "Description is required";


        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        const formData = new FormData();
        formData.append("name", "Featured Category");
        formData.append("title", title);
        formData.append("is_title_active", isTitleActive ? 1 : 0);
        formData.append("small_heading", smallHeading);
        formData.append("is_small_heading_active", isSmallHeadingActive ? 1 : 0);
        formData.append("description", description);
        formData.append("is_description_active", isDescriptionActive ? 1 : 0);
        formData.append("product_source", "new_arrivals");
        formData.append("is_active", isActive ? 1 : 0);

        const id = listData?.[0]?.id;

        try {
            await UpdateLIst({ formData, id }).unwrap();
            alert("Section Updated successfully!");
            setTitle("");
            setIsTitleActive(1);
            setSmallHeading("");
            setIsSmallHeadingActive(1);
            setDescription("");
            setIsDescriptionActive(1);


            setIsActive(1);
            setErrors({});
            setApiError(null);
            navigate("/home");
            refetch();
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };


    if (isLoadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Latest Product</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/home"><span>Home</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">Edit</span>
                </p>
            </div>
            <div className="content-wrapper">
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <div>
                                    <label className="me-3">
                                        <input
                                            type="radio"
                                            name="isActive"
                                            value={1}
                                            checked={isActive === 1}
                                            onChange={() => setIsActive(1)}
                                        />Show
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="isActive"
                                            value={0}
                                            checked={isActive === 0}
                                            onChange={() => setIsActive(0)}
                                        /> Hide
                                    </label>
                                    <div className="tooltip-container">
                                        <FontAwesomeIcon
                                            icon={faCircleInfo}
                                            className="text-warning mx-2"
                                            style={{ cursor: "pointer" }}
                                        />
                                        <div className="tooltip">Show/Hide this section</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        {/* Title */}
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Title</label>
                                <input type="text" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} />
                                {errors.title && <p className="text-danger">{errors.title}</p>}
                            </div>
                        </div>

                        {/* Title Active */}
                        <div className="col-md-6 d-flex align-center">
                            <div className="mb-4 text-start">
                                <div>
                                    <label className="me-3">
                                        <input
                                            type="radio"
                                            name="titleActive"
                                            value={1}
                                            checked={isTitleActive === 1}
                                            onChange={() => setIsTitleActive(1)}
                                        /> Show
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="titleActive"
                                            value={0}
                                            checked={isTitleActive === 0}
                                            onChange={() => setIsTitleActive(0)}
                                        /> Hide
                                    </label>
                                    <div className="tooltip-container">
                                        <FontAwesomeIcon
                                            icon={faCircleInfo}
                                            className="text-warning mx-2"
                                            style={{ cursor: "pointer" }}
                                        />
                                        <div className="tooltip">Enable/Disable Title</div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Small Heading */}
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Subtitle</label>
                                <input type="text" className="form-control" value={smallHeading} onChange={(e) => setSmallHeading(e.target.value)} />
                                {errors.smallHeading && <p className="text-danger">{errors.smallHeading}</p>}
                            </div>
                        </div>

                        {/* Small Heading Active */}
                        <div className="col-md-6 d-flex align-center">
                            <div className="mb-4 text-start">
                                <div>
                                    <label className="me-3">
                                        <input
                                            type="radio"
                                            name="smallHeadingActive"
                                            value={1}
                                            checked={isSmallHeadingActive === 1}
                                            onChange={() => setIsSmallHeadingActive(1)}
                                        /> Active
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="smallHeadingActive"
                                            value={0}
                                            checked={isSmallHeadingActive === 0}
                                            onChange={() => setIsSmallHeadingActive(0)}
                                        /> Inactive
                                    </label>
                                    <div className="tooltip-container">
                                        <FontAwesomeIcon
                                            icon={faCircleInfo}
                                            className="text-warning mx-2"
                                            style={{ cursor: "pointer" }}
                                        />
                                        <div className="tooltip">Enable/Disable Subtitle</div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Description */}
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Description</label>
                                <textarea className="form-control" rows={4} value={description} onChange={(e) => setDescription(e.target.value)} />
                                {errors.description && <p className="text-danger">{errors.description}</p>}
                            </div>
                        </div>

                        {/* Description Active */}
                        <div className="col-md-6 d-flex align-center">
                            <div className="mb-4 text-start">
                                <div>
                                    <label className="me-3">
                                        <input
                                            type="radio"
                                            name="descriptionActive"
                                            value={1}
                                            checked={isDescriptionActive === 1}
                                            onChange={() => setIsDescriptionActive(1)}
                                        /> Show
                                    </label>
                                    <label>
                                        <input
                                            type="radio"
                                            name="descriptionActive"
                                            value={0}
                                            checked={isDescriptionActive === 0}
                                            onChange={() => setIsDescriptionActive(0)}
                                        /> Hide
                                    </label>
                                    <div className="tooltip-container">
                                        <FontAwesomeIcon
                                            icon={faCircleInfo}
                                            className="text-warning mx-2"
                                            style={{ cursor: "pointer" }}
                                        />
                                        <div className="tooltip">Enable/Disable Description</div>
                                    </div>
                                </div>
                            </div>
                        </div>



                        {/* Is Active */}


                    </div>
                    {apiError && <p className="text-danger text-center">{apiError}</p>}
                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default AddCategory;
